module.exports = __webpack_public_path__ + "media/headerBg.mp4";